import moment from 'moment-timezone';

export class ValidateDate {
    static earlierFromNow(date, tz) {
        if(!date) return false;
        return moment(date).tz(tz) < moment().tz(tz);
    }

    static houresRangeLimitExceeded(startDate, endDate, maxHours, minHours, tz) {
        if(!startDate || !endDate) return false;
        var duration = moment.duration(moment(endDate).tz(tz).diff(moment(startDate).tz(tz)));
        var hours = duration.asHours();

        return hours > maxHours || hours < minHours;
    }

    static isSameOrBeforeNow(date, tz) {
        if(!date) return false;
        return moment(date).tz(tz).isSameOrBefore(moment().tz(tz))
    }

    static itsPast(date, tz) {
        if(!date) return false;
        return moment(date).tz(tz).isBefore(moment().tz(tz))
    }

    static status(date = {start: null, end: null, timeZone: null}, closed = false) {
        const eventStarted = ValidateDate.isSameOrBeforeNow(date.start, date.timeZone);
        const eventFinised = ValidateDate.itsPast(date.end, date.timeZone);

        if(eventFinised) return 'finished'; // end
        if(eventStarted && !eventFinised) { // open
            return closed ? 'tmpClosed' : 'open'; // tmp closed ?
        }
        if(!eventStarted && !eventFinised) return 'wait'; // not started yet
    }
}


// WEBPACK FOOTER //
// ./src/helper/validateDate.js